import { NavigationAwareObject } from '../NavigationAwareObject';
import { NavigationBehaviour } from './NavigationBehaviour';
import { Subscription } from 'rxjs';
import { Scene } from '../../scene/Scene';
import { vec3 } from 'gl-matrix';
import { RayTraceResult } from '../../math';
import { PathNode } from '../../navigation-mesh';
import { VisualPathNodes } from '../../development/VisualPathNodes';
import { LineList } from '../../development/LineList';

export class InputControlledBehaviour implements NavigationBehaviour {
  private pathSubscription?: Subscription;

  constructor(public scene: Scene) {}

  attach(navObject: NavigationAwareObject) {
    let debugViewLines = this.scene.debugManager.add('player-path-line', false);

    this.pathSubscription = navObject.pathChanged.subscribe((nodes) => {
      if (nodes.length > 0) {
        let debugPathNodes = new VisualPathNodes(this.scene.ctx);
        debugPathNodes.setPathNodes(nodes.map((node) => node.node));

        let pathLine = new LineList(this.scene.ctx);
        let points = [
          navObject.movement.positionObject.position,
          ...nodes.map((s) => s.position),
        ].map((p) => vec3.fromValues(p[0], p[1] + 1, p[2]));

        pathLine.setLines(points);
        debugViewLines.objects = [pathLine];
      }
    });

    let clickCallback = (treeType: string, eventType: string, hits: RayTraceResult[]) => {
      if (eventType !== 'mouseDown') {
        return false;
      }

      let target: PathNode | undefined;
      let intersection: vec3 | undefined;

      for (let hit of hits) {
        let candidate = hit.object as PathNode;
        if (candidate.neighbours.length === 0) continue;
        let candidateIntersection = candidate.getRayIntersection(hit.ray, false);
        if (candidateIntersection) {
          target = candidate;
          intersection = candidateIntersection;
          break;
        }
      }

      if (!intersection) {
        for (let hit of hits) {
          let candidate = hit.object as PathNode;
          if (candidate.neighbours.length === 0) continue;
          let candidateIntersection = candidate.getRayIntersection(hit.ray, true);
          if (candidateIntersection) {
            target = candidate;
            intersection = candidateIntersection;
            break;
          }
        }
      }

      if (!intersection) {
        console.warn('Clicked but no intersection within the bounding box was found?');
        return true;
      }

      if (target) {
        navObject.navigateToNode(target, intersection, {
          maxRadius: this.scene.navigation.pathFinder.playerRadius,
        });
      }
      return true;
    };

    this.scene.pickingManager.registerSpatialDatabase(
      this.scene.navigation.database,
      'nav-mesh',
      clickCallback,
      100,
    );
  }

  detach(navObject: NavigationAwareObject) {
    this.pathSubscription?.unsubscribe();
    this.scene.debugManager.disable('player-path');
    this.scene.pickingManager.unregisterSpatialDatabase(this.scene.navigation.database);
  }
}
